import { render, staticRenderFns } from "./super-title.vue?vue&type=template&id=4bad108a&scoped=true&"
import script from "./super-title.vue?vue&type=script&lang=js&"
export * from "./super-title.vue?vue&type=script&lang=js&"
import style0 from "./super-title.vue?vue&type=style&index=0&id=4bad108a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bad108a",
  null
  
)

export default component.exports